<template>
  <div id="hytzsmb">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hytzsmb'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/notice/HytzsMb.vue